module.exports = __webpack_public_path__ + "static/media/fredrik-berglund.8b0f600b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/member-photos/fredrik-berglund.jpg
// module id = 207
// module chunks = 0